export enum MissionAcceptanceStatus {
  todo = 'todo',
  inProgress = 'in_progress',
  toValidate = 'to_validate',
  validated = 'validated',
  ignored = 'ignored'
}
